import { ManageTable, type ManageField } from "@/components/ManageTable";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";
import { usePersistentState } from "@/hooks/usePersistentState";

export default function Withdrawal() {
  const [common, setCommon] = usePersistentState("admin:withdrawal:common", true);
  const [filters, setFilter, clearFilters] = usePersistentState<Record<string, any>>(
    "admin:withdrawal:filters",
    {},
  );

  const handleResetFilters = () => {
    clearFilters();
  };

  const fields: ManageField[] = [
    {
      desc: "name",
      field: "name",
    },
    {
      desc: "withdraw_money",
      field: "withdraw_money",
      Comp: <Input type="number" />,
    },
    {
      desc: "flow_bit",
      field: "flow_bit",
      render: (val, row) => {
        const flowBit = (row.current_flow / row.withdraw_money).toFixed(2);
        return flowBit;
      },
    },
    {
      desc: "bank_account_name",
      field: "bank_account_name",
    },
    {
      desc: "bank_name",
      field: "bank_name",
    },
    {
      desc: "bank_account",
      field: "bank_account",
    },
    {
      desc: "create_time",
      field: "create_time",
    },
    {
      desc: "status",
      field: "status",
    },
  ];

  const fields2: ManageField[] = [
    {
      desc: "name",
      field: "name",
    },
    {
      desc: "withdraw_money",
      field: "withdraw_money",
    },
    {
      desc: "status",
      field: "status",
    },
    {
      desc: "order_no",
      field: "order_no",
    },
    {
      desc: "withdraw_time",
      field: "withdraw_time",
    },
  ];

  const filterUI = (
    <div className="flex gap-4 items-center justify-between w-full">
      <div className="flex gap-4 items-center min-w-[500px]">
        <Input
          placeholder="账号"
          className="w-[150px]"
          value={filters.name || ""}
          onChange={(e) => {
            const newFilters = { ...filters };
            if (e.target.value) {
              newFilters.name = e.target.value;
            } else {
              delete newFilters.name;
            }
            setFilter(newFilters);
          }}
        />
        <Input
          placeholder="名字"
          className="w-[150px]"
          value={filters.bank_account_name || ""}
          style={{ visibility: common ? "hidden" : "visible" }}
          onChange={(e) => {
            const newFilters = { ...filters };
            if (e.target.value) {
              newFilters.bank_account_name = e.target.value;
            } else {
              delete newFilters.bank_account_name;
            }
            setFilter(newFilters);
          }}
        />
        <Input
          placeholder="地址"
          className="w-[150px]"
          value={filters.bank_account || ""}
          style={{ visibility: common ? "hidden" : "visible" }}
          onChange={(e) => {
            const newFilters = { ...filters };
            if (e.target.value) {
              newFilters.bank_account = e.target.value;
            } else {
              delete newFilters.bank_account;
            }
            setFilter(newFilters);
          }}
        />
      </div>
      <div className="flex items-center gap-2">
        <Switch
          checked={common}
          onCheckedChange={setCommon}
        />
        <Label>简化视图</Label>
      </div>
    </div>
  );

  return (
    <div className="h-full p-6 overflow-auto">
      <h1 className="text-2xl font-bold mb-6">提现管理</h1>
      <ManageTable
        fields={common ? fields2 : fields}
        collect={common ? "TX" : "withdrawal_log"}
        filters={filters}
        filter={filterUI}
        onResetFilters={handleResetFilters}
      />
    </div>
  );
}
